var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c(
        "w-breadcrumb",
        [
          _c("w-spacer"),
          _c(
            "w-button",
            {
              staticClass: "cancel mr",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
          ),
          _c(
            "w-button",
            {
              attrs: {
                disabled: _vm.isSaving || _vm.stocks.length == 0,
                icon: "save",
              },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
          ),
        ],
        1
      ),
      _c(
        "w-container",
        [
          _c(
            "w-row",
            {
              style: { flexGrow: 1, position: "relative", marginBottom: 0 },
              attrs: { grow: "", shrink: "" },
            },
            [
              _c(
                "w-col",
                {
                  staticClass: "max-height",
                  style: { heigth: "100%" },
                  attrs: { xs: "12" },
                },
                [
                  _c(
                    "w-card",
                    {
                      staticClass: "root",
                      style: { height: "100%" },
                      attrs: { grow: "" },
                    },
                    [
                      _c(
                        "w-card-content",
                        { style: { flexGrow: 0 } },
                        [
                          _c("app-edit-row", {
                            attrs: { value: _vm.selectedRow },
                            on: {
                              add: function ($event) {
                                return _vm.addRow($event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c("app-table", {
                        attrs: {
                          items: _vm.stocks,
                          "selected-row": _vm.selectedRow,
                        },
                        on: {
                          select: function ($event) {
                            return _vm.editRow($event)
                          },
                          remove: function ($event) {
                            return _vm.onRemove($event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }